<div
  class="stats-widget"
  *ngIf="WidgetColorType == 'normal'"
  (click)="emitStatId()"
  [ngStyle]="hasBorder ? { border: '2px solid ' + borderColor } : {}"
>
  <!--  statistics icon  -->
  <div class="stats-icon" [class]="type">
    <img
      *ngIf="imageIcon"
      [src]="icon"
    />
    <i [class]="icon" *ngIf="!imageIcon"></i>
  </div>

  <!--  statistics details  -->
  <div class="stats-details">
    <strong class="stats-count">{{ count ?? 0 }}{{hasPercentage ? '%':''}} {{ hasCurrency ? currency: ''}}</strong>
    <!-- <strong class="stats-count" *ngIf="(count == null) && innovation" -->
    <h3
    [translatable]="{
      transKey: title,
      modEnum: titleTranslationModuleEnum
    }"
    class="stats-title" [ngStyle]="{ color: titleColor }"
  >
    {{ title | translate}}
  </h3>
  </div>
</div>

<div
  *ngIf="WidgetColorType == 'colorFul'"
  class="stats-widget"
  (click)="emitStatId()"
  [ngStyle]="{ 'background-color': widgetColor }"
>
  <!--  statistics icon container  -->
  <div
    class="stats-icon"
    [ngStyle]="{
      'background-color': iconContainerColor
    }"
  >
    <!--  statistics icon  -->
    <i
      [class]="icon"
      [ngStyle]="{
        color: iconColor,
        'background-color': iconBGColor
      }"
    ></i>
  </div>

  <!--  statistics details  -->
  <div class="stats-details">
    <strong class="stats-count" [ngStyle]="{ color: textColor }">
      {{ count }}{{ hasPercentage ? " %" : "" }}
    </strong>
    <h3
      [translatable]="{
        transKey: titleTranslationKey,
        modEnum: titleTranslationModuleEnum
      }"
      class="stats-title"
      [ngStyle]="{ color: textColor }"
    >
      {{ title }}
    </h3>
  </div>
</div>
